module.exports = __webpack_public_path__ + "assets/img/99e90a6880d52d050183c091f14f3284.svg";